// extracted by mini-css-extract-plugin
export default {"data":"tablerow_data__y1Zyl","dataheader":"tablerow_dataheader__boBOn","datadetail":"tablerow_datadetail__zhSM4"};